// extracted by mini-css-extract-plugin
module.exports = {"pageWrap":"CommunityCompanyQuestionsPage_pageWrap__YMl4L"};